import * as styles from "./ComboboxTrigger.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Combobox as BaseCombobox } from "@base-ui/react/combobox";

import { useComboboxContext } from "./Combobox.context";
import type { ComboboxTriggerProps } from "./Combobox.types";

export function ComboboxTrigger({
  className,
  children,
  ...props
}: ComboboxTriggerProps): JSX.Element {
  const { size } = useComboboxContext();

  return (
    <BaseCombobox.Trigger
      data-slot="combobox-trigger"
      className={clsx(styles.trigger({ size }), className)}
      {...props}
    >
      {children}
    </BaseCombobox.Trigger>
  );
}
